export default __webpack_public_path__ + "static/darkStatic-002f0b01e73d92716989329792d35540.webp";